import { ParsedMathJax } from '../../pages/components/ParsedMathJax';
import { ApiResponse, OrganisationApi, PatchDocumentFromJSON } from '../../api/core';
import * as React from 'react';
import { NavigateFunction } from 'react-router';
import { IntlShape } from 'react-intl';
import { ToastContextType } from '../providers/ToastProvider';

export const requestDeleteOrganisation = (organisationApi: OrganisationApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, organisationId: number, organisationTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <ParsedMathJax content={intl.formatMessage({id: 'organisation.deleteRequest.popup.message(organisationTitle)'}, {organisationTitle})} />,
    header: intl.formatMessage({id: 'message.deleteRequest.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async () => {
      try {
        await organisationApi.updateOrganisation({
          organisationId,
          patchDocument: [
            PatchDocumentFromJSON({
              op: 'replace',
              path: '/adminDataOrganisation/editorialStatus',
              value: 'deleted',
            }),
          ],
        });
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletionRequest.success.title'}),
          detail: intl.formatMessage({id: 'message.deletionRequest.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/organisations');
      } catch (e) {
        console.error('Deletion request: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletionRequest.failed.title'}),
          message: intl.formatMessage({id: 'message.deletionRequest.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};

export const deleteOrganisation = (organisationApi: OrganisationApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, organisationId: number, organisationTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <div>
        <p>{intl.formatMessage({id: 'organisation.delete.popup.message'})}</p>
        <p><strong><ParsedMathJax content={organisationTitle} /> (ID: {organisationId})</strong></p>
      </div>,
    header: intl.formatMessage({id: 'organisation.delete.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async () => {
      try {
        const response: ApiResponse<void> = await organisationApi.deleteOrganisationRaw({organisationId});
        if (!response.raw.ok) {
          throw new Error(response.raw.statusText);
        }
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletion.success.title'}),
          detail: intl.formatMessage({id: 'message.deletion.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/organisations');
      } catch (e) {
        console.error('Delete failed: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletion.failed.title'}),
          message: intl.formatMessage({id: 'message.deletion.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};
